import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { isNil } from 'lodash'

import { fetchConnectionDrives } from '@/reducers/organizations/documentSourceConnection.actions'

/**
 * The connection's drives, with their synced stamps. Manage files opens on a stamped drive
 * during the first backfill, before any sync row has a last-synced time.
 *
 * @param {number|null} props.connectionId the document source connection; null while creating
 * @param {boolean} props.skip true to fetch nothing, as for a connection in review
 * @returns {Object[]} the connection's drives; empty while loading, on failure, or while skipped
 */
export const useConnectionDrives = ({ connectionId, skip }) => {
  const dispatch = useDispatch()
  const [drives, setDrives] = useState([])

  useEffect(() => {
    if (skip) {
      return undefined
    }

    let current = true
    dispatch(fetchConnectionDrives({ connectionId })).then(({ data }) => {
      if (current && !isNil(data)) {
        setDrives(data)
      }
    })
    return () => {
      current = false
    }
  }, [dispatch, connectionId, skip])

  return drives
}
